/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/require-param */
/* eslint-disable no-alert */
// University Modules Tiles

// Phone Verification Tilesimport React from 'react';
import React, { useState, useEffect } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import {
  getUniversityStatus,
  fetchAllModules,
  fetchOtherUserCriteria,
} from "../shared/functions/getUniversityStatus";
import UniversityTile from "./UniversityTile";
import DetailsVerificationTile from "./DetailsVerificationTile";
import { useCompany } from "../../contexts/CompanyContext";

/**
 * A component that displays the user's training and verification status.
 *
 * The component is split into two sections. The first section displays the user's
 * training status, showing the number of modules they have passed out of the total.
 * The second section displays the user's verification status, showing if their phone
 * and email addresses have been verified or not.
 *
 * If the user is not verified, the component provides a button to resend the verification
 * link or OTP.
 *
 * @param {object} currentUser - The current user's data.
 * @param {boolean} otherProfile - If the component is being used to display another user's profile.
 */
export default function SnapshotTiles({ currentUser, otherProfile = false }) {
  const [loading, setLoading] = useState(true);
  const [suppliers, setSuppliers] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [allModules, setAllModules] = useState([]);
  const [error, setError] = useState(0);

  const {
    activeSuppliers: companySuppliers,
    productTypes: companyProductTypes,
  } = useCompany();

  const universityStatus = getUniversityStatus(
    currentUser,
    suppliers,
    productTypes,
    allModules,
    error
  );

  const updateAllModules = async () => {
    setLoading(true);
    const allModulesResult = await fetchAllModules(currentUser.id);
    if (allModulesResult.error) {
      throw new Error(allModulesResult.error);
    }

    setAllModules(allModulesResult.data);
    setLoading(false);
  };

  const updateCompanyValues = async () => {
    setLoading(true);
    if (otherProfile) {
      const otherUserCritResult = await fetchOtherUserCriteria(currentUser.id);

      if (otherUserCritResult.error) {
        throw new Error(otherUserCritResult.error);
      }

      setSuppliers(otherUserCritResult.data.activeSuppliers);
      setProductTypes(otherUserCritResult.data.productTypes);
    } else {
      setSuppliers(companySuppliers);
      setProductTypes(companyProductTypes);
    }
    setLoading(false);
  };

  useEffect(() => {
    try {
      updateCompanyValues();
      updateAllModules();
    } catch (err) {
      console.error(err);
      setError(err);
    }
  }, [currentUser]);

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Grid style={{ marginTop: 10 }} container spacing={2}>
          <UniversityTile
            otherProfile={otherProfile}
            currentUser={currentUser}
            universityStatus={universityStatus}
          />
          <DetailsVerificationTile
            currentUser={currentUser}
            otherProfile={otherProfile}
          />
        </Grid>
      )}
    </div>
  );
}
